import { Zap, Crown } from "lucide-react";
import { useUserQuery } from "@/api/v1/user-api";
import { Skeleton } from "@/components/ui/skeleton";

export function PlanIndicator() {
  const { data: user, isLoading } = useUserQuery();
  
  // Active subscription statuses (user still has access)
  const activeStatuses = ["active", "trialing", "past_due", "incomplete"];
  const isSubscriptionActive = user?.subscription_status 
    ? activeStatuses.includes(user.subscription_status)
    : false;
  
  // Treat canceled/expired subscriptions as Free (no active subscription)
  // Only show Pro if subscription_plan_slug is "pro" AND status is one of the active statuses
  const currentPlan = 
    user?.subscription_plan_slug === "pro" && isSubscriptionActive
      ? "Pro"
      : "Free";
  const isPro = currentPlan === "Pro";

  if (isLoading) {
    return (
      <div className="bg-muted/50 rounded-lg p-3">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-4 rounded" />
          <Skeleton className="h-4 w-16" />
        </div>
        <Skeleton className="mt-1 h-3 w-24" />
      </div>
    );
  }

  return (
    <div className="bg-muted/50 rounded-lg p-3">
      <div className="flex items-center gap-2">
        {isPro ? (
          <Crown className="h-4 w-4 text-primary" />
        ) : (
          <Zap className="h-4 w-4 text-muted-foreground" />
        )}
        <span className="text-sm font-medium">{currentPlan} Plan</span>
      </div>
      <div className="mt-1 text-xs text-muted-foreground">
        {isPro 
          ? "Premium features active"
          : "Upgrade to unlock premium features"}
      </div>
    </div>
  );
}
